import script from "./FlowReplyText.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowReplyText.vue?vue&type=script&setup=true&lang=js"

import "./FlowReplyText.vue?vue&type=style&index=0&id=6a8827d2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8827d2"]])

export default __exports__